<template>
    <div v-if="order && order.FISNO">
        <div class="row border-bottom pb-1 mb-2">
            <div class="col-6"><strong>Sipariş No:</strong> {{ order.FISNO }}</div>
            <div class="col-6"><strong>Müşteri:</strong> {{ order.CARI_UNVAN }}</div>
        </div>

        <div v-for="(kalem, index) in localItems" :key="index" class="row align-items-center mb-1">
            <div class="col-12">
                <strong>Stok Kodu:</strong> {{ kalem.STOK_KODU }}
                <small class="text-muted">(Sipariş Miktarı: {{ kalem.STHAR_GCMIK }})</small>
            </div>
            <div class="col-md-8">
                <b-form-group label="Kaynak Hücre">
                    <v-select
                        v-model="kalem.selectedCell"
                        :options="getAvailableCellsForStock(kalem.STOK_KODU)"
                        label="CellLocation.CellName"
                        placeholder="Hücre seçin..."
                        v-on:input="onCellSelect(kalem)"
                    >
                        <template #option="{ CellLocation, Balance }"> {{ CellLocation.CellName }} (Mevcut: {{ Balance }}) </template>
                        <template #selected-option="{ CellLocation, Balance }"> {{ CellLocation.CellName }} (Mevcut: {{ Balance }}) </template>
                    </v-select>
                </b-form-group>
            </div>
            <div class="col-md-4">
                <b-form-group label="Sevk Edilecek Miktar">
                    <b-form-input v-model.number="kalem.pickedQuantity" type="number" />
                </b-form-group>
            </div>
        </div>

        <hr />
        <div class="text-right">
            <button type="button" class="btn btn-success" @click="completeShipment">Sevkiyatı Tamamla</button>
        </div>
    </div>
</template>

<script>
import { Toast } from "bootstrap";
import { BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
    name: "ShipmentPickingView",
    components: { BFormGroup, BFormInput, vSelect },
    props: {
        order: { type: Object, required: true },
        allBalances: { type: Array, required: true },
    },
    data() {
        return {
            localItems: [],
        };
    },
    watch: {
        order: {
            immediate: true,
            handler(newOrder) {
                this.localItems = newOrder.Kalemler
                    ? JSON.parse(JSON.stringify(newOrder.Kalemler)).map((item) => ({
                          ...item,
                          selectedCell: null,
                          pickedQuantity: item.STHAR_GCMIK,
                      }))
                    : [];
            },
        },
    },
    methods: {
        getAvailableCellsForStock(stockCode) {
            if (!window.debugged) {
                console.log("ARANAN Stok Kodu (kalemden gelen):", stockCode);
                console.log("ARAMA YAPILAN Bakiye Listesi (allBalances):", this.allBalances);
                window.debugged = true;
            }

            return this.allBalances.filter((b) => b.StockCode === stockCode && b.Balance > 0);
        },
        onCellSelect(kalem) {
            if (!kalem.selectedCell) return;
            if (kalem.pickedQuantity > kalem.selectedCell.Balance) {
                kalem.pickedQuantity = kalem.selectedCell.Balance;
            }
        },
        completeShipment() {
            const shipmentPayload = this.localItems
                .filter((item) => item.selectedCell && item.pickedQuantity > 0)
                .map((item) => ({
                    FromCellCode: item.selectedCell.CellLocation.CellCode,
                    StockCode: item.STOK_KODU,
                    Quantity: item.pickedQuantity,
                    OutFatirsNo: this.order.FISNO,
                    CariKodu: this.order.CARI_KODU,
                }));

            if (shipmentPayload.length === 0) {
                this.$bvToast.toast("Lütfen sevk edilecek en az bir ürün için kaynak hücre ve miktar belirtin.", {
                    title: "Uyarı",
                    variant: "warning",
                    solid: true,
                });
                return;
            }

            this.$emit("ship-items", shipmentPayload);
        },
    },
};
</script>
